import { forwardRef } from 'react';

type Props = React.SVGAttributes<SVGSVGElement>;
type Ref = SVGSVGElement;

const Error = forwardRef<Ref, Props>((props, ref) => (
    <svg
        width='18'
        height='18'
        viewBox='0 0 21 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
        ref={ref}
    >
        <path
            d='M11.4545 11.3684H9.54545V6.63158H11.4545M11.4545 15.1579H9.54545V13.2632H11.4545M0 18H21L10.5 0L0 18Z'
            fill='#23B3E5'
        />
    </svg>
));

export default Error;
